/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Map_Popup_Routes_TitleInputs */

const en_ui_map_popup_routes_title = /** @type {(inputs: Ui_Map_Popup_Routes_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Routes`)
};

const de_ui_map_popup_routes_title = /** @type {(inputs: Ui_Map_Popup_Routes_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Routen`)
};

/**
* | output |
* | --- |
* | "{count} Routes" |
*
* @param {Ui_Map_Popup_Routes_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_map_popup_routes_title = /** @type {((inputs: Ui_Map_Popup_Routes_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Map_Popup_Routes_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_map_popup_routes_title(inputs)
	return de_ui_map_popup_routes_title(inputs)
});